"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXStrategyV1ABI = void 0;
class VXStrategyV1ABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "rateUPLS",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "uPLSInStake",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "PLSToSwap",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "lastSplitTimestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "swapRouterV2",
                                "type": "address"
                            },
                            {
                                "internalType": "address[]",
                                "name": "swapPath",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMinPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMaxPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "sendPLSIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendPLSReceiver",
                                "type": "address"
                            },
                            {
                                "internalType": "uint256",
                                "name": "bnsIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendAddress",
                                "type": "address"
                            },
                            {
                                "internalType": "bool",
                                "name": "isBurnWithERC20Burn",
                                "type": "bool"
                            }
                        ],
                        "internalType": "struct VXProxyUser.Scope",
                        "name": "scope_",
                        "type": "tuple"
                    }
                ],
                "name": "config",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "swapMaxSlippageIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitMinProfitAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "maxGasAmount",
                                "type": "uint256"
                            }
                        ],
                        "internalType": "struct VXStrategy.BotConfig",
                        "name": "botConfig_",
                        "type": "tuple"
                    }
                ],
                "name": "configureBot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "strategy_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount_",
                        "type": "uint256"
                    }
                ],
                "name": "feed",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "transferOwnership",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousOwner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "OwnershipTransferred",
                "type": "event"
            },
            {
                "inputs": [
                    {
                        "internalType": "address[]",
                        "name": "bots_",
                        "type": "address[]"
                    },
                    {
                        "internalType": "bool",
                        "name": "value_",
                        "type": "bool"
                    }
                ],
                "name": "setBots",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address[]",
                        "name": "routers_",
                        "type": "address[]"
                    },
                    {
                        "internalType": "bool",
                        "name": "value_",
                        "type": "bool"
                    }
                ],
                "name": "setRoutersV2",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "strategy_",
                        "type": "address"
                    },
                    {
                        "internalType": "bool",
                        "name": "needUnstake_",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "needWithdraw_",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "needSwap_",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minSwapRate_",
                        "type": "uint256"
                    }
                ],
                "name": "update",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "strategy_",
                        "type": "address"
                    }
                ],
                "name": "updateUPLSRate",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "configs",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "swapMaxSlippageIndex",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "swapFrequencySeconds",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "splitFrequencySeconds",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "splitMinProfitAmount",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxGasAmount",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "skip",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "take",
                        "type": "uint256"
                    }
                ],
                "name": "getStrategies",
                "outputs": [
                    {
                        "internalType": "address[]",
                        "name": "result_",
                        "type": "address[]"
                    },
                    {
                        "internalType": "uint256",
                        "name": "length_",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "isBot",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "isRouterV2",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "strategies",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "name": "strategiesList",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "uPLSToken",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "wPLSToken",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            }
        ];
    }
}
exports.VXStrategyV1ABI = VXStrategyV1ABI;
//# sourceMappingURL=VXStrategyV1ABI.js.map